export default "__VITE_ASSET__d83e6f90__"